var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"layout-oneside",attrs:{"id":"inspire"}},[_c('v-main',[_c('v-container',{staticClass:"authContent fill-height py-0",attrs:{"fluid":""}},[_c('router-view')],1)],1),_c('GlobalSnackbar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }